export enum CustomerBrandingAccessTokenStatus {
  Pending = 1,
  Active = 2,
  Rejected = 3,
  Terminated = 4,
  Expired = 5,
}
